export const featuredPortfolio = [
  {
    id: 1,
    title: 'e-commerce APP',
    img: './assets/projects/oneDshop.png',
    link: 'https://one-d-shop.herokuapp.com',
  },
  {
    id: 2,
    title: 'Full Stack Real Estate',
    img: 'https://www.webeera.com/wp-content/uploads/2021/08/real-estate-script.png',
    link: 'https://github.com/JuandiM/MERN_real_estate',
  },
  {
    id: 3,
    title: 'Popcorn APP',
    img: 'https://miro.medium.com/max/1400/1*3sSuM1iGe7vNQEQar2rzJg.png',
    link: 'https://popcornmovie.herokuapp.com',
  },
  {
    id: 4,
    title: 'Netflix Clone APP',
    img: 'https://vuejsexamples.com/content/images/2021/08/example2.png',
    link: 'https://github.com/JuandiM/clone_netflix',
  },
  {
    id: 5,
    title: 'Animated Navbar',
    img: 'https://cdn4.vectorstock.com/i/1000x1000/93/53/setting-icon-vector-21009353.jpg',
    link: 'https://codepen.io/juandim/pen/LYzxJeX',
  },
  {
    id: 6,
    title: 'My First Game',
    img: 'https://images.thedirect.com/media/photos/Iron_Man.jpg',
    link: 'https://juandim.github.io/project-the-game/',
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: 'Netflix clone APP',
    img: 'https://vuejsexamples.com/content/images/2021/08/example2.png',
    link: 'https://github.com/JuandiM/clone_netflix',
  },
  {
    id: 2,
    title: 'Popcorn',
    img: 'https://miro.medium.com/max/1400/1*3sSuM1iGe7vNQEQar2rzJg.png',
    link: 'https://one-d-shop.herokuapp.com',
  },
  {
    id: 3,
    title: 'e-commerce APP',
    img: './assets/projects/oneDshop.png',
    link: 'https://one-d-shop.herokuapp.com',
  },
  {
    id: 4,
    title: 'Full Stack Blog APP',
    img: 'https://miro.medium.com/max/1400/1*hI-u28Pd_ipHCr8N_huYqQ.png',
    link: 'https://github.com/JuandiM/mern_blog_app',
  },
];

export const responsivePortfolio = [
  {
    id: 1,
    title: 'e-commerce APP',
    img: './assets/projects/oneDshop.png',
    link: 'https://one-d-shop.herokuapp.com',
  },
  {
    id: 2,
    title: 'Netflix Clone APP',
    img: 'https://vuejsexamples.com/content/images/2021/08/example2.png',
    link: 'https://github.com/JuandiM/clone_netflix',
  },
  {
    id: 3,
    title: 'My Portfolio',
    img: 'https://png.pngitem.com/pimgs/s/238-2384334_my-portfolio-cover-design-hd-png-download.png',
    link: 'https://one-d-shop.herokuapp.com',
  },
  {
    id: 4,
    title: 'Full Stack Real Estate',
    img: 'https://www.webeera.com/wp-content/uploads/2021/08/real-estate-script.png',
    link: 'https://github.com/JuandiM/MERN_real_estate',
  },
];

export const componentsPortfolio = [
  {
    id: 1,
    title: 'Animated Navbar',
    img: 'https://cdn4.vectorstock.com/i/1000x1000/93/53/setting-icon-vector-21009353.jpg',
    link: 'https://codepen.io/juandim/pen/LYzxJeX',
  },
  {
    id: 2,
    title: 'React slider',
    img: 'https://cdn4.vectorstock.com/i/1000x1000/93/53/setting-icon-vector-21009353.jpg',
    link: 'https://github.com/JuandiM',
  },
  {
    id: 3,
    title: 'Clone design',
    img: 'https://assets.codepen.io/2425199/internal/screenshots/pens/BqKooQ.default.png?fit=cover&format=auto&ha=false&height=540&quality=75&v=2&version=1539027052&width=960',
    link: 'https://codepen.io/juandim/pen/eYvaMVe',
  },
];
